/* Relocate Dawn's built-in quick-add action into each product image.
   Preserve native Shopify add-to-cart, variant modal and cart drawer behavior. */
(() => {
  'use strict';

  function moveActions() {
    document.querySelectorAll('.product-card-wrapper').forEach((wrapper) => {
      if (wrapper.classList.contains('phannies-quick-add-ready')) return;
      const card = wrapper.querySelector(':scope > .card');
      const image = card?.querySelector(':scope > .card__inner');
      const info = card?.querySelector(':scope > .card__content');
      const action = info?.querySelector(':scope > .quick-add');
      if (!image || !action || card.classList.contains('card--horizontal')) return;

      // Dawn's quick-add modal normally moves itself to document.body.
      // Keep any not-yet-moved modal outside the transformed image container.
      action.querySelectorAll('quick-add-modal').forEach((modal) => info.appendChild(modal));
      image.appendChild(action);
      image.classList.add('phannies-quick-add-overlay');
      wrapper.classList.add('phannies-quick-add-ready');
    });
  }

  let scheduled = false;
  function scheduleMove() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      moveActions();
    });
  }

  function init() {
    moveActions();
    document.addEventListener('shopify:section:load', scheduleMove);
    const observer = new MutationObserver((mutations) => {
      if (mutations.some((change) => [...change.addedNodes].some((node) =>
        node.nodeType === 1 &&
        (node.matches?.('.product-card-wrapper') || node.querySelector?.('.product-card-wrapper'))
      ))) {
        scheduleMove();
      }
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();